import { get } from 'modules/api';

export const fetchAllProductType = (data = null, headers = null, isPublicRequest = false) =>
    get('product_types/', data, headers, isPublicRequest);
export const getProductTypesAllLevels = () => get('product_types/all_levels');
